import { useLang } from "@/i18n";
import { Link } from "react-router-dom";
import { Phone, Mail, Instagram } from "lucide-react";

export function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-[#FAF9F6] border-t border-[#222]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="mb-6">
            <img src="/logo-light.png" alt="Funghetto Roma" className="h-9 w-auto" />
          </div>
          <p className="text-sm text-[#999] leading-relaxed">{t.footer.address}</p>
        </div>
        <div>
          <h4 className="text-[10px] uppercase tracking-[0.3em] text-[#888] mb-6">{t.footer.contacts}</h4>
          <p className="text-sm text-[#CCC] leading-loose">
            <a data-testid="footer-phone" href="https://wa.me/393520981771" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#6B1E33] transition-colors"><Phone size={14} /> +39 352 098 1771</a><br />
            <a data-testid="footer-email" href="mailto:info@funghettoroma.it" className="inline-flex items-center gap-2 hover:text-[#6B1E33] transition-colors"><Mail size={14} /> info@funghettoroma.it</a><br />
            <a data-testid="footer-instagram" href="https://www.instagram.com/funghetto.roma" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-[#6B1E33] transition-colors"><Instagram size={14} /> @funghetto.roma</a>
          </p>
        </div>
        <div>
          <h4 className="text-[10px] uppercase tracking-[0.3em] text-[#888] mb-6">{t.footer.hours}</h4>
          <p className="text-sm text-[#CCC] leading-loose">
            <span className="text-[#6B1E33]">{t.footer.everyday}</span>
          </p>
        </div>
        <div className="flex flex-col justify-between gap-8">
          <a href="#prenota" data-testid="footer-book-btn"
             className="text-center text-xs uppercase tracking-[0.25em] border border-[#FAF9F6] px-6 py-4 hover:bg-[#6B1E33] hover:border-[#6B1E33] transition-colors duration-300">
            {t.nav.book}
          </a>
          <Link to="/admin" data-testid="footer-admin-link" className="text-[10px] uppercase tracking-[0.3em] text-[#666] hover:text-[#FAF9F6] transition-colors">
            {t.nav.admin}
          </Link>
        </div>
      </div>
      <div className="border-t border-[#222] py-6 text-center text-[10px] uppercase tracking-[0.3em] text-[#666]">
        © {new Date().getFullYear()} Funghetto Roma — P.IVA 18366311001 — {t.footer.rights}
        <span className="mx-2">·</span>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#FAF9F6] transition-colors">Privacy Policy</Link>
        <span className="mx-2">·</span>
        <Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-[#FAF9F6] transition-colors">Cookie Policy</Link>
      </div>
    </footer>
  );
}
